export default __webpack_public_path__ + "static/media/Avatar2.a4cbd03b.mp3";